let isReady = false
let socket = null
let heart = null
const defaults = {
  env: 'develop',
  loanId: -1,
  token: '1'
}

/**
 * Create A Websocket Object
 */
export function LockSocket (options) {
  this.initOptions(options)
}

LockSocket.prototype = {
  constructor: this,
  initOptions: function (options) {
    this.defaults = extend(defaults, options, true)
    this.eventListeners = []
    this.eventHandlers = {}
  },
  init: function () {
    initWebsocket(this)
    return this
  },
  on: function (type, handler) {
    if (typeof this.eventHandlers[type] === 'undefined') {
      this.eventHandlers[type] = []
    }
    this.eventListeners.push(type)
    this.eventHandlers[type].push(handler)
    return this
  },
  sendMessage: function (message) {
    if (isReady && socket != null) {
      socket.send(message)
    }
  },
  close: function () {
    socket.close()
    clearInterval(heart)
    heart = null
  },
  triggerEvent: function (type, data) {
    if (this.eventHandlers[type] instanceof Array) {
      const eventHandlers = this.eventHandlers[type]
      for (let i = 0, length = eventHandlers.length; i < length; ++i) {
        eventHandlers[i]({
          type: type,
          target: this,
          data: data
        })
      }
      return true
    }
    return false
  }
}

/**
 * Init websocket and Build Connection
 */
function initWebsocket (wsxch) {
  if ('WebSocket' in window) {
    const protocol = window.location.protocol === 'http:'
    const wsUrl = protocol ? 'ws:' : 'wss:'
    let slothUrl = ''
    switch (process.env.NODE_ENV) {
      case 'develop':
        if (protocol) {
          slothUrl = 'MICROSERVICE-WSXCH-DEV-V3-2.us-west-1.elasticbeanstalk.com:8407/v3'
        } else {
          slothUrl = 'wsxch3.sztnb.com/v3'
        }
        break
      case 'training':
        if (protocol) {
          slothUrl = 'MICROSERVICE-WSXCH-DEV-V3-2.us-west-1.elasticbeanstalk.com:8407/v3'
        } else {
          slothUrl = 'wsxch3.sztnh.com/v3'
        }
        break
      case 'production':
        if (protocol) {
          slothUrl = 'microservice-wsxch-rel-v3-2.ap-southeast-1.elasticbeanstalk.com:8407/v3'
        } else {
          slothUrl = 'wsxchv3e2.sztus.com/v3'
        }
        break
      default :
        slothUrl = process.env.VUE_APP_WEBSOCKET_URL
        break
    }
    socket = new WebSocket('{0}//{1}/lock/{2}/{3}'.format(
      wsUrl,
      slothUrl,
      wsxch.defaults.loanId,
      wsxch.defaults.token
    ))
    socket.onopen = function () {
      isReady = true
      heartbeat(wsxch)
    }
    socket.onclose = function (e) {
      this.close()
    }
    socket.onmessage = function (event) {
      wsxch.triggerEvent('message', event.data)
    }
  }
}

function heartbeat (wsxch) {
  heart = setInterval(function () {
    wsxch.sendMessage('1')
  }, 20 * 1000)
}

function extend (target, data, override) {
  for (const key in data) {
    // eslint-disable-next-line no-prototype-builtins
    if (data.hasOwnProperty(key) && (!target.hasOwnProperty(key) || override)) {
      target[key] = data[key]
    }
  }
  return target
}

// eslint-disable-next-line no-extend-native
String.prototype.format = function (args) {
  let result = this
  if (arguments.length > 0) {
    if (arguments.length === 1 && typeof (args) === 'object') {
      for (const key in args) {
        if (args[key] !== undefined) {
          const reg = new RegExp('({' + key + '})', 'g')
          result = result.replace(reg, args[key])
        }
      }
    } else {
      for (let i = 0; i < arguments.length; i++) {
        if (arguments[i] !== undefined) {
          const reg = new RegExp('({)' + i + '(})', 'g')
          result = result.replace(reg, arguments[i])
        }
      }
    }
  }
  return result
}
